import { FC } from 'react'
import { UnsubmittedBody } from './UnsubmittedBody'
import { SubmittedBody } from './SubmittedBody'
import { twMerge } from '@lib/tailwind-merge'
import { TimeCardsContextTimeCard } from '@features/time-logging/providers/TimeCardsContextProvider'

interface Props {
  timeCard: TimeCardsContextTimeCard
  className: string
}

export const Body: FC<Props> = ({ timeCard, className }) => {
  return (
    <div className={twMerge('grow flex flex-col mx-2', className)}>
      {timeCard.submitted ? (
        <SubmittedBody timeCard={timeCard} />
      ) : (
        <UnsubmittedBody timeCard={timeCard} />
      )}
    </div>
  )
}
